import React from 'react'

// Local Components
import { MemberInvite } from '../MemberInvite'

// Styles
import { Wrapper } from './CreateWorkspaceInvitePartners.styles'

import { Text } from '@sketch/components'

// Types
import { Member, WorkspaceMembers } from '../../types'

// Utils
import { useAnalytics } from '@sketch/modules-common'
import { useAnalyticsFormContext } from '../../views/CreateWorkspaceView/CreateWorkspaceView.hooks'
import { ItemPartners } from '../MembersList/components/ItemPartners'

interface CreateWorkspaceInvitePeopleProps {
  members: WorkspaceMembers
  onMembersUpdate: (members: WorkspaceMembers) => void
  onMembersDelete: (members: WorkspaceMembers) => void
  isWorkspaceCreated: boolean
  isDisabled: boolean
}

/**
 * CreateWorkspaceInvitePeople
 *
 * This page is responsible for rendering the components
 * that will enable the user to invite members to a workspace and
 * change user roles
 */
export const CreateWorkspaceInvitePartners: React.FC<CreateWorkspaceInvitePeopleProps> = props => {
  const {
    members,
    onMembersUpdate,
    isWorkspaceCreated,
    isDisabled,
    onMembersDelete,
  } = props

  const { trackEvent } = useAnalytics()
  const analyticsFormContext = useAnalyticsFormContext()

  const handleRemove = (member: Member) =>
    onMembersDelete(
      members.filter(prevMember => prevMember.email !== member.email)
    )

  const handleInvite = async (newMember: Member) => {
    if (members.find(member => member.email === newMember.email)) {
      throw new Error('Already a workspace member')
    } else {
      trackEvent('CREATE WORKSPACE - member invited', {
        formContext: analyticsFormContext,
      })
      onMembersUpdate([...members, newMember])
    }
  }

  const memberWithoutOwner = members?.filter(member => !member.isOwner)

  return (
    <Wrapper>
      <Text color="foreground.secondary.C" fontSize="E">
        Invite Workspace Owner
      </Text>
      <MemberInvite
        onInvite={handleInvite}
        isDisabled={
          isDisabled || isWorkspaceCreated || memberWithoutOwner?.length > 0
        }
        isPartner
      />
      {memberWithoutOwner?.length > 0 && (
        <ItemPartners member={memberWithoutOwner[0]} onRemove={handleRemove} />
      )}
    </Wrapper>
  )
}
